module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component.scss
// module id = ./src/app/shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component.scss
// module chunks = main